import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { inject } from '@angular/core';
import { AuthStore } from '../../features/auth/store/auth.store';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
    let clonedRequest = req;

    if (!req.headers.has('x-api-key')) {
        clonedRequest = req.clone({
            setHeaders: {
                'x-api-key': environment.api_key,
            },
        });
    }

    if (req.url.includes('/admin')) {
        const authStore = inject(AuthStore);
        const token = authStore.token();
        clonedRequest = clonedRequest.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    return next(clonedRequest);
};
